module.exports = __webpack_public_path__ + "img/daniel-melo.cce970a5.png";